<div class="console-page">
  <div class="console-content">
    <app-page-header
      title="Checkout React SDK (QR)"
      description="SDK React v2 con pago QR (UMD por defecto)."
    ></app-page-header>

    <form [formGroup]="myForm">
      <input type="hidden" formControlName="orderId" />

      <app-console-section title="Configuración API">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="reactqr-env">Ambiente SDK</label>
            <select id="reactqr-env" class="console-select" formControlName="env">
              <option value="QAV1">QA</option>
              <option value="QAnL&F">QA Nuevo Look&amp;Feel</option>
              <option value="PROD/QA">SDK de PROD con ambiente de QA</option>
              <option value="PROD">PROD</option>
              <option value="PRODCORD">PROD Cord-1.0.0</option>
            </select>
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-field__label" for="reactqr-sdkUrl">URL SDK (UMD)</label>
            <input
              id="reactqr-sdkUrl"
              class="console-input"
              formControlName="sdkUrl"
              placeholder="Bundle UMD del React SDK"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-merchantKey">API Key</label>
            <input
              id="reactqr-merchantKey"
              class="console-input"
              formControlName="merchantKey"
              placeholder="API Key"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-merchantToken">Secret Key</label>
            <input
              id="reactqr-merchantToken"
              class="console-input"
              formControlName="merchantToken"
              placeholder="Clave secreta"
              type="text"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-merchantStoreCode">Código de tienda</label>
            <input
              id="reactqr-merchantStoreCode"
              class="console-input"
              formControlName="merchantStoreCode"
              placeholder="Código de tienda"
            />
          </div>

          <div class="console-field">
            <span class="console-field__label">ID de orden</span>
            <div class="console-field__order-id">
              <span class="mono">{{ myForm.get('orderId')?.value }}</span>
              <app-copy-button [value]="myForm.get('orderId')?.value" ariaLabel="Copiar ID de orden"></app-copy-button>
            </div>
            <span class="console-field__hint">Se actualiza automáticamente cada segundo</span>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-currency">Moneda</label>
            <input
              id="reactqr-currency"
              class="console-input"
              formControlName="currency"
              placeholder="Moneda"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-expirationDate">Expiración (ISO)</label>
            <input
              id="reactqr-expirationDate"
              class="console-input"
              formControlName="expirationDate"
              placeholder="2029-12-31T23:59:59.999-0500"
            />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Pago">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="reactqr-discounts">Descuento</label>
            <input
              id="reactqr-discounts"
              class="console-input"
              formControlName="discounts"
              placeholder="Descuento"
              type="number"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-taxes">Impuestos</label>
            <input
              id="reactqr-taxes"
              class="console-input"
              formControlName="taxes"
              placeholder="Impuestos"
              type="number"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-shipping">Envío</label>
            <input
              id="reactqr-shipping"
              class="console-input"
              formControlName="shipping"
              placeholder="Envío"
              type="number"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="reactqr-fee">Tarifa</label>
            <input
              id="reactqr-fee"
              class="console-input"
              formControlName="fee"
              placeholder="Tarifa"
              type="number"
            />
          </div>
        </div>

        <div class="minicart-container" [formGroup]="minicartItems">
          <div class="console-form-grid">
            <div class="console-field">
              <label class="console-field__label" for="reactqr-minicart-sku">SKU</label>
              <input id="reactqr-minicart-sku" class="console-input" formControlName="sku" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="reactqr-minicart-name">Nombre</label>
              <input id="reactqr-minicart-name" class="console-input" formControlName="name" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="reactqr-minicart-category">Categoría</label>
              <input id="reactqr-minicart-category" class="console-input" formControlName="category" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="reactqr-minicart-amount">Precio unitario</label>
              <input id="reactqr-minicart-amount" class="console-input" formControlName="amount" type="number" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="reactqr-minicart-quantity">Cantidad</label>
              <input id="reactqr-minicart-quantity" class="console-input" formControlName="quantity" type="number" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="reactqr-minicart-discount">Descuento ítem</label>
              <input id="reactqr-minicart-discount" class="console-input" formControlName="discount" type="number" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="reactqr-minicart-shipping">Envío ítem</label>
              <input id="reactqr-minicart-shipping" class="console-input" formControlName="shipping" type="number" />
            </div>
          </div>

          <div class="add-item-button">
            <button class="console-btn" type="button" (click)="addMinicartItem()">Agregar ítem</button>
          </div>

          <div class="cart-items-container" *ngIf="items.length; else emptyCart">
            <div class="demo-minicart-row demo-minicart-row--head">
              <span>SKU</span>
              <span>Producto</span>
              <span>Total</span>
              <span>Cant.</span>
              <span></span>
            </div>
            <div *ngFor="let item of items; let i = index" class="demo-minicart-row">
              <span class="demo-minicart-row__mono">{{ item.sku }}</span>
              <span>{{ item.name }}</span>
              <span>{{ item.amount }}</span>
              <span>{{ item.quantity }}</span>
              <button
                class="console-btn"
                type="button"
                (click)="removeMinicartItem(i)"
                aria-label="Quitar"
              >
                Quitar
              </button>
            </div>
          </div>
          <ng-template #emptyCart>
            <p class="demo-minicart-empty">No hay ítems en el carrito. Agregá uno para probar el minicart.</p>
          </ng-template>
        </div>
      </app-console-section>

      <app-console-section title="Cliente">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="reactqr-identifier">Identificador</label>
            <input
              id="reactqr-identifier"
              class="console-input"
              formControlName="identifier"
              placeholder="Identificador"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-email">Email</label>
            <input
              id="reactqr-email"
              class="console-input"
              formControlName="email"
              type="email"
              placeholder="Email"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-name">Nombre</label>
            <input id="reactqr-name" class="console-input" formControlName="name" placeholder="Nombre" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-lastname">Apellido</label>
            <input
              id="reactqr-lastname"
              class="console-input"
              formControlName="lastname"
              placeholder="Apellido"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-documentType">Tipo doc.</label>
            <input
              id="reactqr-documentType"
              class="console-input"
              formControlName="documentType"
              placeholder="Ej. DNI"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-documentNumber">Nº documento</label>
            <input
              id="reactqr-documentNumber"
              class="console-input"
              formControlName="documentNumber"
              placeholder="Documento"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-phone">Teléfono</label>
            <input id="reactqr-phone" class="console-input" formControlName="phone" placeholder="Teléfono" />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Dirección">
        <div class="console-form-grid">
          <div class="console-field console-form-grid__full">
            <label class="console-field__label" for="reactqr-address1">Dirección línea 1</label>
            <input
              id="reactqr-address1"
              class="console-input"
              formControlName="address1"
              placeholder="Dirección"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-addressCountry">País</label>
            <input
              id="reactqr-addressCountry"
              class="console-input"
              formControlName="addressCountry"
              placeholder="País"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-addressLevel1">Nivel 1</label>
            <input id="reactqr-addressLevel1" class="console-input" formControlName="addressLevel1" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-addressLevel2">Nivel 2</label>
            <input id="reactqr-addressLevel2" class="console-input" formControlName="addressLevel2" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-addressLevel3">Nivel 3</label>
            <input id="reactqr-addressLevel3" class="console-input" formControlName="addressLevel3" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="reactqr-addressZip">ZIP</label>
            <input id="reactqr-addressZip" class="console-input" formControlName="addressZip" placeholder="ZIP" />
          </div>
        </div>
      </app-console-section>

      <div *ngIf="loadError" class="alert-banner alert-banner--error">{{ loadError }}</div>
    </form>
  </div>

  <div class="console-action-bar">
    <span class="console-action-bar__total">
      Total
      <span class="console-action-bar__amount">S/ {{ calculateTotal() }}</span>
    </span>
    <button
      class="console-btn"
      type="button"
      [disabled]="loadingSdk || myForm.invalid"
      (click)="generatePayment('#cart-container-2')"
    >
      {{ loadingSdk ? 'Cargando SDK…' : 'Pagar con QR (embebido)' }}
    </button>
    <button
      class="console-btn console-btn--primary"
      type="button"
      [disabled]="loadingSdk || myForm.invalid"
      (click)="generatePayment('#cart-container')"
    >
      {{ loadingSdk ? 'Cargando SDK…' : 'Pagar con QR (modal)' }}
    </button>
  </div>

  <dialog #dialog class="demo-pay-dialog dialog">
    <div class="demo-pay-dialog__inner">
      <div class="demo-pay-dialog__header">
        <button
          type="button"
          class="demo-pay-dialog__close"
          (click)="closePaymentWindow(); $event.stopPropagation()"
          aria-label="Cerrar"
        >
          ×
        </button>
      </div>
      <div class="pay-container">
        <div id="cart-container" class="epago-container" #cartContainer></div>
      </div>
    </div>
  </dialog>

  <div id="cart-container-2" class="epago-container embedded-sdk" #cartContainer2></div>
</div>
